module.exports = __webpack_public_path__ + "img/ic-payfast.57f674d6.jpg";